module.exports = __webpack_public_path__ + "img/wide.78893938.jpg";